import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';

import LoadingSpinner from '../../../../components/Spinner';
import { getCompanyStats, selectCompanyDepartments, selectCompanyStats } from '../../../../redux/modules/company';
import AdminSearchPanel from '../AdminSearchPanel';

import DepartmentRow from './components/DepartmentRow';

const DepartmentsTabPanel = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCompanyStats());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const companyStats = useSelector(selectCompanyStats);
  const departments = useSelector(selectCompanyDepartments);

  const searchFunction = (searchData, search) => (
    searchData.filter(d => d.departmentName.toLowerCase().includes(search)
      || d.departmentId.toString().includes(search))
  );

  const displayDepartmentRow = allDepartments => allDepartments.map(dept => (
    <DepartmentRow
      currentDepartmentStats={companyStats.filter(stats => stats.departmentId === dept.departmentId)?.[0]}
      department={dept}
      key={dept.departmentId}
    />
  ));

  if (!departments || !departments.length || !companyStats) return <LoadingSpinner />;

  return (
    <Box mt={7}>
      <AdminSearchPanel
        allActive={departments.filter(department => !department.archivedAt)}
        allData={departments}
        allInactive={departments.filter(department => department.archivedAt)}
        rowFunction={displayDepartmentRow}
        searchFunction={searchFunction}
        sortFunction={((a, b) => b.archivedAt - a.archivedAt)}
        tabName="department"
      />

    </Box>
  );
};

export default DepartmentsTabPanel;
